<div class="flex flex-col gap-4 items-center justify-center bg-gray-50">
  <div class="w-full grid gap-x-4 grid-cols-5 w-1/2">
    <span>
      Carousel Width: <b>{{ carouselWidth }}{{ widthUnit }}</b>
    </span>
    <mat-slider class="col-span-3" [min]="0" [max]="100" [step]="1">
      <input matSliderThumb [(ngModel)]="carouselWidth" (ngModelChange)="refresh()" />
    </mat-slider>
    <mat-form-field>
      <mat-label>Unit</mat-label>
      <input matInput type="text" placeholder="Unit" (ngModelChange)="refresh()" [(ngModel)]="widthUnit" />
    </mat-form-field>

    <span>
      Slide Height: <b>{{ slideHeight }}{{ heightUnit }}</b>
    </span>
    <mat-slider class="col-span-3" [min]="1" [max]="40" [step]="1">
      <input matSliderThumb [(ngModel)]="slideHeight" (ngModelChange)="refresh()" />
    </mat-slider>
    <mat-form-field>
      <mat-label>Unit</mat-label>
      <input matInput type="text" placeholder="Unit" (ngModelChange)="refresh()" [(ngModel)]="heightUnit" />
    </mat-form-field>

    <span>
      Slide Border Radius: <b>{{ slideBorderRadius }}{{ borderRadiusUnit }}</b>
    </span>
    <mat-slider class="col-span-3" [min]="0" [max]="100" [step]="1">
      <input matSliderThumb [(ngModel)]="slideBorderRadius" (ngModelChange)="refresh()" />
    </mat-slider>
    <mat-form-field>
      <mat-label>Unit</mat-label>
      <input matInput type="text" placeholder="Unit" (ngModelChange)="refresh()" [(ngModel)]="borderRadiusUnit" />
    </mat-form-field>

    <mat-checkbox [(ngModel)]="useSlideBorder" (ngModelChange)="refresh()"> Show slide border?</mat-checkbox>

    <mat-checkbox [(ngModel)]="useCardsAsSlides" (ngModelChange)="refresh()"> Use Material Addon Cards as slides? </mat-checkbox>

    <mat-checkbox [(ngModel)]="loop" (ngModelChange)="refresh()"> Loop carousel?</mat-checkbox>
  </div>

  @if (carouselVisible) {
    <mad-carousel
      [options]="options"
      [width]="carouselWidth + widthUnit"
      [slideHeight]="slideHeight + heightUnit"
      [useSlideBorder]="useSlideBorder"
      [slideBorderRadius]="slideBorderRadius + borderRadiusUnit"
    >
      @if (useCardsAsSlides) {
        <mad-card madCarouselSlide [madCarouselShortText]="'Card 1'" [expandable]="false" [readonly]="true" title="Slide 1">
          <div class="grid grid-cols-4 mt-4">
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Max'">
              <mat-form-field class="form-group">
                <mat-label>First Name</mat-label>
                <input autocomplete="off" class="form-control" id="firstName" matInput name="firstName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Mustermann'">
              <mat-form-field class="form-group">
                <mat-label>Last Name</mat-label>
                <input autocomplete="off" class="form-control" id="lastName" matInput name="lastName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Musterstrasse 13'">
              <mat-form-field class="form-group">
                <mat-label>Street</mat-label>
                <input autocomplete="off" class="form-control" id="street" matInput name="street" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Musterstadt'">
              <mat-form-field class="form-group">
                <mat-label>City</mat-label>
                <input autocomplete="off" class="form-control" id="city" matInput name="city" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'1010'">
              <mat-form-field class="form-group">
                <mat-label>Zip-Code</mat-label>
                <input autocomplete="off" class="form-control" id="zip" matInput name="zip" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
          </div>
        </mad-card>
        <mad-card madCarouselSlide [madCarouselShortText]="'Card 2'" [expandable]="false" [readonly]="true" title="Slide 2">
          <div class="grid grid-cols-4 mt-4">
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Himmel'">
              <mat-form-field class="form-group">
                <mat-label>First Name</mat-label>
                <input autocomplete="off" class="form-control" id="firstName" matInput name="firstName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Hiro'">
              <mat-form-field class="form-group">
                <mat-label>Last Name</mat-label>
                <input autocomplete="off" class="form-control" id="lastName" matInput name="lastName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Heldenplatz 1'">
              <mat-form-field class="form-group">
                <mat-label>Street</mat-label>
                <input autocomplete="off" class="form-control" id="street" matInput name="street" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Hauptstadt'">
              <mat-form-field class="form-group">
                <mat-label>City</mat-label>
                <input autocomplete="off" class="form-control" id="city" matInput name="city" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'1000'">
              <mat-form-field class="form-group">
                <mat-label>Zip-Code</mat-label>
                <input autocomplete="off" class="form-control" id="zip" matInput name="zip" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
          </div>
        </mad-card>
        <mad-card madCarouselSlide [madCarouselShortText]="'Card 3'" [expandable]="false" [readonly]="true" title="Slide 3">
          <div class="grid grid-cols-4 mt-4">
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Hansi'">
              <mat-form-field class="form-group">
                <mat-label>First Name</mat-label>
                <input autocomplete="off" class="form-control" id="firstName" matInput name="firstName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper [readonly]="true" [value]="'Hinterseer'">
              <mat-form-field class="form-group">
                <mat-label>Last Name</mat-label>
                <input autocomplete="off" class="form-control" id="lastName" matInput name="lastName" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Musterstrasse 55'">
              <mat-form-field class="form-group">
                <mat-label>Street</mat-label>
                <input autocomplete="off" class="form-control" id="street" matInput name="street" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'Rasterstadt'">
              <mat-form-field class="form-group">
                <mat-label>City</mat-label>
                <input autocomplete="off" class="form-control" id="city" matInput name="city" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
            <mad-readonly-form-field-wrapper class="row-start-2" [readonly]="true" [value]="'5511'">
              <mat-form-field class="form-group">
                <mat-label>Zip-Code</mat-label>
                <input autocomplete="off" class="form-control" id="zip" matInput name="zip" />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
          </div>
        </mad-card>
      } @else {
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
          <div madCarouselSlide class="flex flex-col gap-4">
            <h1>Slide {{ i }}</h1>
            <p class="text-justify">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna
              aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
              takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
              eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
              et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
              consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
              Lorem ipsum dolor sit amet.
            </p>
          </div>
        }
      }
    </mad-carousel>
  }
</div>
